import { ImageAsset } from "@/components/ImageAsset";
import { PlayIconCircle } from "@/components/icons";
import { nextTrackState, playerPlaylistState } from "@/context/states";
import { basierCirleBold } from "@/styles/fonts";
import { CardActionArea } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { useRecoilState } from "recoil";
import theme from "../styles/theme";
import MusicExploreCardBands from "./MusicExploreCardBands";

export const MusicExploreCard = ({
  playlist,
  active,
  prefix = "Top of",
  imageRatioSquare = false,
  onPlay,
}) => {
  const [nextTrack, setNextTrack] = useRecoilState(nextTrackState);
  const [playerPlaylist, setPlayerPlaylist] =
    useRecoilState(playerPlaylistState);

  const bands = () => {
    let bands = [];
    for (const song of playlist.songs) {
      if (bands.findIndex((b) => b.id === (song.band.id ?? song.band)) === -1) {
        bands = [...bands, song.band.id ?? song.band];
      }
    }

    return bands || [];
  };

  const play = () => {
    setPlayerPlaylist(playlist.songs);
    setNextTrack(playlist.songs[0]);

    if (onPlay && typeof onPlay === "function") {
      onPlay(playlist);
    }
  };

  return (
    <>
      <Card
        elevation={0}
        variant={
          active?.id === playlist?.id
            ? "MusicExploreCardPlay"
            : "MusicExploreCard"
        }
        sx={style}
      >
        <CardActionArea sx={{ position: "relative" }}>
          <Box className="MusicExploreCard--Badge">
            <Typography className="badge-text">
              <Box component="span">{prefix}</Box> {playlist.title}
            </Typography>
          </Box>
          <ImageAsset
            url={playlist?.image?.formats.small.url}
            layout="responsive"
            width={imageRatioSquare ? "1080" : "1920"}
            height={1080}
          />
          <Box className="MusicExploreCard--Gradientoverlay"></Box>
          <IconButton onClick={play} className="play-button">
            <SvgIcon>
              <PlayIconCircle />
            </SvgIcon>
          </IconButton>
        </CardActionArea>
        <CardContent sx={{ p: 3 }}>
          <Grid container>
            <Grid item xs={12}>
              <MusicExploreCardBands bands={bands()} count={5} />
            </Grid>
          </Grid>
        </CardContent>
        <Box sx={{ padding: "0 1.5rem 1.5rem 1.5rem", marginTop: "auto" }}>
          <Grid item xs={12} sx={{ mt: "auto" }}>
            <Link href={`/playlist/${playlist.slug}`} passHref legacyBehavior>
              <Button fullWidth variant="outlined-white">
                Playlist anzeigen
              </Button>
            </Link>
          </Grid>
        </Box>
      </Card>
    </>
  );
};

const style = {
  display: "flex",
  flexDirection: "column",
  position: "relative",
  color: theme.palette.common.white,
  transition: "all .2s ease-in-out",
  overflow: "visible",
  height: "100%",

  "& .MusicExploreCard--Badge": {
    position: "absolute",
    top: ".5rem",
    left: "-.5rem",
    padding: ".25rem 1rem",
    zIndex: "50",
    transition: ".2s ease-in-out",
    "&::after": {
      content: "''",
      position: "absolute",
      bottom: "-.5625rem",
      left: "0",
      borderBottom: "solid .01875rem transparent",
      borderLeft: "solid .53125rem transparent",
    },
  },

  "& .badge-text": {
    textTransform: "uppercase",
    fontSize: ".9375rem",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1.375rem",
    },
    "& .MuiBox-root": {
      fontFamily: basierCirleBold.style.fontFamily,
      fontWeight: basierCirleBold.style.fontWeight,
    },
  },

  "& .play-button": {
    position: "absolute",
    zIndex: "50",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    marginTop: "auto",
    marginRight: "auto",
    marginBottom: "auto",
    marginLeft: "auto",
    "& .MuiSvgIcon-root": {
      fontSize: 60,
      color: theme.palette.common.white,
      [theme.breakpoints.up("sm")]: {
        fontSize: 72,
      },
    },
  },

  "& .bands": {
    textTransform: "uppercase",
    fontSize: "0.9375rem",
    textAlign: "center",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem",
    },
    "& .MuiLink-root": {
      fontFamily: basierCirleBold.style.fontFamily,
      fontWeight: basierCirleBold.style.fontWeight,
    },
  },
};
